import { render, staticRenderFns } from "./TranscriptEntry.vue?vue&type=template&id=4c1ba4d7&scoped=true&"
import script from "./TranscriptEntry.vue?vue&type=script&lang=ts&"
export * from "./TranscriptEntry.vue?vue&type=script&lang=ts&"
import style0 from "./TranscriptEntry.vue?vue&type=style&index=0&id=4c1ba4d7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ba4d7",
  null
  
)

export default component.exports